export default __webpack_public_path__ + "static/media/barChart.ddbde7b2.svg";